import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import TptArrivePage from './pages/TptArrivePage';
import DashboardPage from './pages/DashboardPage';
import AccountPage from './pages/AccountPage';
import GameSetupPage from './pages/GameSetupPage';
import HostPage from './pages/HostPage';
import JoinPage from './pages/JoinPage';
import BingoCardPage from './pages/BingoCardPage';
import CustomListsPage from './pages/CustomListsPage';
import CustomListNewPage from './pages/CustomListNewPage';
import CustomListEditPage from './pages/CustomListEditPage';
import PricingPage from './pages/PricingPage';
import DemoPage from './pages/DemoPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangeEmailPage from './pages/ChangeEmailPage';
import ConfirmEmailChangePage from './pages/ConfirmEmailChangePage';
import LandingPage from './pages/LandingPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminNovelsPage from './pages/admin/AdminNovelsPage';
import AdminNovelEditPage from './pages/admin/AdminNovelEditPage';
import AdminUtmPage from './pages/admin/AdminUtmPage';
import AdminAccountsPage from './pages/admin/AdminAccountsPage';

// Phase 2+ placeholder pages
const ComingSoon = ({ label }) => (
  <div style={{ padding: '48px', textAlign: 'center', color: '#6b6b7a', fontFamily: 'system-ui, sans-serif' }}>
    <h2 style={{ color: '#1a1a2e' }}>{label}</h2>
    <p>Coming in a future phase.</p>
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          {/* TpT UTM arrival — e.g. classroom.bingo/play?novel=frindle */}
          <Route path="/play" element={<TptArrivePage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/confirm-email-change" element={<ConfirmEmailChangePage />} />

          {/* Protected routes — require any valid session */}
          <Route path="/dashboard" element={
            <ProtectedRoute><DashboardPage /></ProtectedRoute>
          } />
          <Route path="/account" element={
            <ProtectedRoute><AccountPage /></ProtectedRoute>
          } />
          <Route path="/change-email" element={
            <ProtectedRoute><ChangeEmailPage /></ProtectedRoute>
          } />

          {/* Phase 2 — Game Engine */}
          <Route path="/game/new" element={
            <ProtectedRoute><GameSetupPage /></ProtectedRoute>
          } />
          <Route path="/host/:code" element={
            <ProtectedRoute><HostPage /></ProtectedRoute>
          } />
          {/* Public — students don't need an account */}
          <Route path="/join" element={<JoinPage />} />
          <Route path="/bingo/:code" element={<BingoCardPage />} />
          <Route path="/lists" element={
            <ProtectedRoute><CustomListsPage /></ProtectedRoute>
          } />
          <Route path="/lists/new" element={
            <ProtectedRoute><CustomListNewPage /></ProtectedRoute>
          } />
          <Route path="/lists/:id/edit" element={
            <ProtectedRoute><CustomListEditPage /></ProtectedRoute>
          } />
          {/* /subscribe and /pricing both render PricingPage.
              /pricing is the Stripe cancel redirect target (Spec §9). */}
          <Route path="/subscribe" element={
            <ProtectedRoute><PricingPage /></ProtectedRoute>
          } />
          <Route path="/pricing" element={
            <ProtectedRoute><PricingPage /></ProtectedRoute>
          } />

          {/* Admin — separate auth, no ProtectedRoute wrapper.
              AdminLayout is mounted once as the parent of these nested
              routes (via <Outlet/>), so its session check and sidebar
              don't get torn down and re-verified on every admin navigation. */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="novels" replace />} />
            <Route path="novels/:id" element={<AdminNovelEditPage />} />
            <Route path="novels" element={<AdminNovelsPage />} />
            <Route path="utm" element={<AdminUtmPage />} />
            <Route path="accounts" element={<AdminAccountsPage />} />
          </Route>

          {/* Static pages — Phase 5 */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/demo" element={<DemoPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
